import React, { useContext, useCallback } from 'react';
import PropTypes from 'prop-types';
import { designSystem } from '@yola/ws-ui';
import ElementSettingsContext from '../helpers/element-settings-context';
import getBatchValues from '../helpers/get-batch-values';

const { Heading, Box, SimpleSelect, HorizontalStack, InfoWithPopover } = designSystem;

function SelectControl({ id, elementIds, attributes, title, choices, popover = null, onChange }) {
  const { state } = useContext(ElementSettingsContext);

  const values = getBatchValues(state, { elementIds, attributes });
  const currentValue = values[0];
  const adaptedOptions = choices.map((el) => ({
    label: el.name,
    value: el.value,
  }));
  const selectedValue = adaptedOptions.find((el) => el.value === currentValue) || adaptedOptions[0];

  const handleChange = useCallback(
    ({ value }) => {
      onChange({ controlId: id, elementIds, attributes, value });
    },
    [id, elementIds, attributes, onChange]
  );

  return (
    <Box paddingBottom="spacing-xs" paddingLeft="spacing-m" paddingRight="spacing-m">
      <HorizontalStack verticalAlign="center" align="space-between">
        <HorizontalStack verticalAlign="center">
          <Heading type="heading-6" singleLine>
            {title}
          </Heading>
          {!!popover && (
            <InfoWithPopover
              title={popover.title || ''}
              content={popover.content}
              imgSrc={popover.imgSrc}
            />
          )}
        </HorizontalStack>
        <SimpleSelect
          value={selectedValue}
          options={adaptedOptions}
          menuWidth="auto"
          transparent
          noVerticalSpacing
          noHorizontalSpacing
          noSpacingBetweenElements
          onChange={handleChange}
        />
      </HorizontalStack>
    </Box>
  );
}

SelectControl.propTypes = {
  id: PropTypes.string.isRequired,
  elementIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  attributes: PropTypes.arrayOf(PropTypes.string).isRequired,
  title: PropTypes.string.isRequired,
  choices: PropTypes.array.isRequired,
  popover: PropTypes.shape({
    title: PropTypes.string,
    content: PropTypes.string,
    imgSrc: PropTypes.string,
  }),
  onChange: PropTypes.func.isRequired,
};

export default SelectControl;
